module.exports = __webpack_public_path__ + "img/web2.7fc89cdd.png";